/**
 * /usecases/after-an-outage — a PAGE. AppLayoutRoute supplies the chrome.
 * Content lives in ../data/cases.ts; the template renders it.
 */
import { UseCaseTemplate } from '../components/UseCaseTemplate';

export default function AfterAnOutagePage() {
  return <UseCaseTemplate slug="after-an-outage" />;
}
